import {
  Box,
} from "@chakra-ui/react";
import TableUpdateProjectMechanismImport from "./tableUpdateProjectMechanismImport";
import { useParams } from "react-router-dom";

export default function UpdateProjectMechanismImport() {

  const { saleOpeningEventId } = useParams();

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Box>
        <TableUpdateProjectMechanismImport saleOpeningEventId={saleOpeningEventId} />
      </Box>
    </Box>
  );
}
